<template>
    <div class="content-wrapper">
        <div class="row">
            <div class="col-sm-12 col-md-6">
                <app-breadcrumb :page-title="$t('offices')" :directory="$t('datatables')" :icon="'grid'"/>
            </div>
            <div class="col-sm-12 col-md-6 breadcrumb-side-button">
                <div class="d-flex float-md-right mb-3 mb-sm-3 mb-md-0">
                  <!-- Brochure Button -->
                  <button class="btn btn-success btn-with-shadow mr-2"
                          @click="openBrochureModal">
                    Add brochure
                  </button>

                    <a class="nav-link btn btn-primary btn-with-shadow"
                       href="/office/add">
                         {{ $t('add') }}       
                    </a>
                </div>
            </div>
        </div>

      <!-- Brochure Modal -->
      <div v-if="showBrochureModal" class="modal d-block" style="background:rgba(0,0,0,0.5)">
        <div class="modal-dialog">
          <div class="modal-content">

            <div class="modal-header">
              <h5>Upload Brochure PDF</h5>
              <button class="close" @click="showBrochureModal = false">&times;</button>
            </div>

            <div class="modal-body">
              <input type="file" class="form-control" @change="handleFileUpload" accept="application/pdf">

              <div v-if="previewUrl || oldBrochure" class="mt-3">
                <object :data="previewUrl ? previewUrl : oldBrochure" type="application/pdf" width="100%" height="300px">
                  <p>Your browser does not support PDFs. <a :href="previewUrl ? previewUrl : oldBrochure">Download the PDF</a> instead.</p>
                </object>
              </div>
            </div>

            <div class="modal-footer">
              <button class="btn btn-primary mr-2" @click="uploadBrochure">Upload</button>
              <button class="btn btn-secondary" @click="showBrochureModal = false">Close</button>
            </div>

          </div>
        </div>
      </div>

        <app-table :id="tableId" :options="options" @action="getListAction"/>

        

        <app-delete-modal v-if="deleteConfirmationModalActive"
                                :preloader="deleteLoader"
                                modal-id="demo-delete"
                                @confirmed="confirmed"
                                @cancelled="cancelled"/>
    </div>
</template>

<script>
    import {TableHelpers} from './mixins/TableHelpers';
    import * as actions from '../../../../Config/ApiUrl';
    import {FormMixin} from "../../../../../core/mixins/form/FormMixin";
 

    export default {
        name: "OfficeData",
        mixins: [TableHelpers,FormMixin],
        data() {
            return {
                deleteConfirmationModalActive: false,
                deleteLoader: false,
                tableId: 'office-table',
                rowData: {},
                options: {
                    name: 'OfficeTable',
                    url: actions.GET_Offices,
                    showHeader: true,
                    columns: [],
                    actions: [
                        {
                            title: this.$t('edit'),
                            icon: 'edit',
                            type: 'none',
                            

                        }, {
                            title: this.$t('delete'),
                            icon: 'trash',
                            type: 'none',
                            component: 'app-confirmation-modal',
                            modalId: 'demo-delete',
                        }
                    ],
                    filters: [ 
                        {
                            "title": this.$t('search_and_select'),
                            "type": "search",
                            "key": "search",
                        }
                    ],
                    showFilter: true,
                    showSearch: true,
                    paginationType: "pagination",
                    responsive: true,
                    rowLimit: 10,
                    showAction: true,
                    orderBy: 'desc',
                    actionType: "default",
                },
                brochureFile: null,
                showBrochureModal: false,
                oldBrochure: null,
                previewUrl: null,
            }
        },

        created(){
            this.options.columns = [...this.tableColumns, this.actionObj];
        },
        methods: {
            /**
             * $emit Form datatable action
             */
            getListAction(rowData, actionObj, active) {

                this.rowData = rowData;

                if (actionObj.title == 'Delete') {

                    this.openDeleteModal();
                } else if (actionObj.title == this.$t('edit')) {

                  window.location = `${actions.EDIT_OFFICE}${this.rowData.id}`;
                }
            },

          openBrochureModal() {
            axios.get('/office/get-brochure')
                .then(res => {
                  this.oldBrochure = res.data.brochure_pdf;
                  this.previewUrl = null;
                  this.showBrochureModal = true;
                });
          },

          handleFileUpload(e) {
            const file = e.target.files[0];

            if (file && file.type === "application/pdf") {
              this.brochureFile = file;

              this.previewUrl = URL.createObjectURL(file);

            } else {
              this.$toastr.e('Please select a valid PDF');
            }
          },

          uploadBrochure() {
            if (!this.brochureFile) {
              this.$toastr.e('Please select a PDF file');
              return;
            }

            let formData = new FormData();
            formData.append('file', this.brochureFile);

            axios.post('/office/upload-brochure', formData)
                .then(res => {
                  console.log(res.data)
                  if (res.data.status){
                    this.$toastr.s(res.data.message);
                    this.showBrochureModal = false;
                  }else{
                    this.$toastr.s(res.data.message);
                  }

                })
                .catch(err => {
                  this.$toastr.e('Upload failed');
                });
          },

            /**
             * for open confirmation modal
             */
            openDeleteModal() {
                this.deleteConfirmationModalActive = true;
            },

            /**
             * confirmed $emit Form confirmation modal
             */
            confirmed() {
                let url = `${actions.DELETE_OFFICE}${this.rowData.id}`;
                this.deleteLoader=true;
                this.axiosDelete(url)
                    .then(response => {
                        this.deleteLoader= false;
                        $("#demo-delete").modal('hide');
                        this.cancelled();
                        this.$toastr.s(response.data.message);
                    }).catch(({error}) => {

                    //trigger after error
                }).finally(() => {
                    this.$hub.$emit('reload-' + this.tableId);
                });
            },

            /**
             * cancelled $emit Form confirmation modal
             */
            cancelled() {
                this.deleteConfirmationModalActive = false;
            },

            reSetData() {
                this.rowData = {};
            },

            
        },
    }
</script>
